module.exports = __webpack_public_path__ + "img/android-zh.973e4768.png";